module.exports = __webpack_public_path__ + "assets/img/fcfe-gb.svg";